export const messages = {
  SAVE_SUCCESS: 'De wijzigingen zijn opgeslagen.',
  SAVE_ERROR: 'Er is iets mis gegaan bij het opslaan.',
  DELETE_CONFIRM: 'Weet je zeker dat je dit item wilt verwijderen?',
};